<template>
  <div class="min-w-[380px] lg:w-[40%]">
    <!-- v-if has data show chart -->
    <apex-chart
      v-if="dataSeriesIsEmpty"
      type="donut"
      :options="pollutantPieChartOptions"
      :series="pollutantBreakdownSeries"
    />
    <!-- v-else show empty state -->
    <div v-else>
      <EmptyDonutPieChart />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PollutantsPieChart',

  props: {
    pollutants: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      selectedPollutants: this.pollutants,
      pollutantBreakdownSeries: [],
      pollutantPieChartOptions: {
        chart: {
          type: 'donut',
          width: 380,
        },
        labels: [],
        colors: [],
        stroke: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        yaxis: {
          labels: {
            formatter(value) {
              return thousands(value, 3)
            },
          },
        },
        plotOptions: {
          pie: {
            donut: {
              size: '70%',
              // background: 'transparent',
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: 'Total',
                  fontFamily: 'Inter, sans-serif',
                  formatter(w) {
                    const total = w.globals.seriesTotals.reduce(
                      (a, b) => a + b,
                      0,
                    )
                    return thousands(total, 3)
                  },
                },
                value: {
                  show: true,
                  fontSize: '20px',
                  fontFamily: 'Inter, sans-serif',
                  fontWeight: 600,
                  color: undefined,
                  formatter(val) {
                    return thousands(val, 3)
                  },
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 380,
              },
              legend: {
                show: false,
              },
              dataLabels: {
                enabled: false,
              },
            },
          },
        ],
      },
    }
  },

  computed: {
    dataSeriesIsEmpty() {
      return [...this.pollutantBreakdownSeries].reduce((a, b) => a + b, 0)
    },
  },

  watch: {
    pollutants(newPollutants) {
      this.selectedPollutants = newPollutants
      this.updatePollutantPieChart(newPollutants)
    },
  },

  methods: {
    updatePollutantPieChart(data) {
      if (data.length) {
        this.pollutantBreakdownSeries = []
        this.pollutantPieChartOptions.labels = []
        this.pollutantPieChartOptions.colors = []
        data.forEach(({ chemical_formula, total_emissions_mtco2 }, index) => {
          this.pollutantBreakdownSeries.push(
            Number(total_emissions_mtco2.toFixed(4)),
          )
          this.pollutantPieChartOptions.labels.push(chemical_formula)
          this.pollutantPieChartOptions.colors.push(
            pollutantChartColors()[index],
          )
        })
      }
    },
  },
}
</script>
